import { DeleteOutlined, DesktopOutlined, DownloadOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React, { useEffect } from 'react'

interface DocumentState {
    fileName: string;
    content: File | null;
    type: number;
}


interface DocumentsItemProps {
    title: string;
    documentFile: DocumentState[] | null; // <-- array now
    error?: string;
    handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleDelete: (index: number) => void;
    setFileKeyForDelete?: (index: number) => void;
    type?: number;
    displayClientDocument: (documentUrl: string | null) => void;
    apiUrl: string;

}

const isAbsoluteUrl = (url: string) => /^https?:\/\//i.test(url);


const DocumentsItem: React.FC<DocumentsItemProps> = ({ title, documentFile, error, handleFileChange, handleDelete, type, displayClientDocument, apiUrl, setFileKeyForDelete }) => {

    useEffect(() => {
        console.log('DocumentsItem rendered');
    }, [documentFile]);

    const buildUrl = (fileName?: string) => {
        if (!fileName) return '';
        return isAbsoluteUrl(fileName) ? fileName : `${apiUrl || ''}${fileName}`;
    };

    const onPreview = (idx: number) => {
        if (!documentFile || !documentFile[idx]) return;
        const url = buildUrl(documentFile[idx].fileName);
        if (url) displayClientDocument(url);
    };

    const onDownload = (idx: number) => {
        if (!documentFile || !documentFile[idx]) return;
        const url = buildUrl(documentFile[idx].fileName);
        if (!url) return;

        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        anchor.download = (documentFile[idx].fileName && documentFile[idx].fileName.split('/').pop() || 'download').toString();
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };

    const onDeleteClick = (idx: number) => {
        // Prime confirm modal index if parent uses it, then trigger parent's delete flow
        if (setFileKeyForDelete) setFileKeyForDelete(idx);
        handleDelete(idx);
    };

    return (
        <div className="documents-item">
            <label className="document-label">
                <div style={{
                    textAlign: 'right',
                    fontSize: '1.2rem'
                }}>{title}</div>
                <input
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.png"
                    className="document-input"
                    onChange={handleFileChange}
                />
            </label>
            {Array.isArray(documentFile) && documentFile.length > 0 && (
                <div className="document-details">
                    {documentFile.map((doc, idx) => (
                        <div key={`${doc.fileName}-${idx}`} className="document-row" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <p className="document-name" style={{ margin: 0, flex: 1 }}>
                                Uploaded: {doc.fileName}
                            </p>
                            {doc && doc.content && doc.content.size ? (
                                <p className="document-size" style={{ margin: 0 }}>
                                    {((doc.content.size / 1024) / 1024).toFixed(2)} MB
                                </p>
                            ) : null}

                            <div className="document-actions" style={{ display: 'flex', alignItems: 'center' }}>
                                <Tooltip title="מחיקה">
                                    <DeleteOutlined
                                        style={{ fontSize: '22px', marginLeft: '20px', color: '#186cc7' }}
                                        onClick={() => onDeleteClick(idx)}
                                    />
                                </Tooltip>

                                <Tooltip title="הצגה">
                                    <DesktopOutlined
                                        style={{ fontSize: '22px', marginLeft: '20px', color: '#186cc7' }}
                                        onClick={() => onPreview(idx)}
                                    />
                                </Tooltip>

                                <Tooltip title="הורדה">
                                    <DownloadOutlined
                                        style={{ fontSize: '22px', marginLeft: '20px', color: '#186cc7' }}
                                        onClick={() => onDownload(idx)}
                                    />
                                </Tooltip>
                            </div>
                        </div>
                    ))}
                </div>

            )}
            {error && <p className="error-message-documents">{error}</p>}
        </div>
    );
}

export default DocumentsItem